import React from 'react';
import { useFieldValue } from '@qover/hooks';
import { DiscountForm } from '@qover/organisms';
import { DiscountCode } from '@qover-private/protos-web/qover/dojo/contracts/v1/contract';
import { Container } from './bikeDiscountBar.styles';
import messages from './bikeDiscountBar.messages';

type BikeDiscountBarProps = {
  addDiscount: (discountCode: string) => Promise<void>;
  removeDiscount: (discountCode: string) => Promise<void>;
};

export const BikeDiscountBar = (props: BikeDiscountBarProps) => {
  const discountCode = useFieldValue<DiscountCode>('discountCodes[0]');

  return (
    <Container>
      <DiscountForm
        title={messages.addDiscount}
        addDiscount={props.addDiscount}
        discountCode={discountCode.name}
        removeDiscount={props.removeDiscount}
        tooltip={messages.tooltip}
      />
    </Container>
  );
};
